module.exports = __webpack_public_path__ + "conheca/static/media/stat5.82499cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Eventos/stat5.png
// module id = 404
// module chunks = 37